import { Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';

export const formatLink = ({ link, linkType, text }: any): Link => {
  return {
    linkType,
    text,
    url: link ?? '',
  };
};
